export const timeFormatter = (
  locale: string,
  hour12: boolean,
  createDate: (
    values?: {
      year?: number;
      month?: number;
      day?: number;
      hours?: number;
      minutes?: number;
      seconds?: number;
    }
  ) => Date,
  formatDate: (dt: Date, options?: any) => string
) => {
  
  const formatTime = (
    hours: number,
    minutes: number
  ): string => {
    return formatDate(
      createDate(
        { year: 1996, month: 11, day: 1, hours, minutes }),
        {
          hour: '2-digit',
          minute: '2-digit',
          hour12 // setting 12 or 24 hour format
        }
    );
  };

  const numericDisplay = (num: number) => {
    return Number(num).toLocaleString(locale);
  };

  // TODO should be merged with formatTime above
  const formatTimePicker = (
    num: number,
    mode: 'info' | 'clock' = 'clock'
  ): string => {    
    let numInCurrentLocale = numericDisplay(num);
    const prefixZeroInCurrentLocale = numericDisplay(0);    

    if (mode === 'info') {
      if(num < 9) {
        numInCurrentLocale = prefixZeroInCurrentLocale + numInCurrentLocale;
      }
    }
    return numInCurrentLocale;
  };

  return {
    formatTimePicker,
    formatTime,
    numericDisplay
  };
};
